<template>
   <Toast />
  <div class="card m-2 p-2">
    <div class="grid grid-cols-6 gap-4">

  

        <div class="col-span-6">
          <label for="nombre-name" class="block text-sm font-medium text-gray-700"> {{facturacionGlobalText}}</label>
          <InputSwitch inputId="nombre-name" v-model="data.save.esEmpresa" @change="switchFacturacion" /> 
          <p class="block text-sm font-medium text-gray-700">{{data.save.esEmpresa ? "Empresas" : "Afiliados"}}</p>
        </div>

        <div class="col-span-6">     
          <AutoComplete v-if="data.save.esEmpresa" v-model="empresa" class="w-full" 
          :suggestions="data.empresasFiltradas" @complete="buscarEmpresa($event)"
          @item-select="saveIdEmpresa" :dropdown="true" optionLabel="nombre"  
          placeholder="Dejar en blanco para facturar a todas las empresas o seleccionar para facturar una única empresa"
          @input="onAutoCompleteInput"/>
        </div>

      <div class="col-span-3 sm:col-span-2">
        <label for="Periodo" class="block text-sm font-medium text-gray-700">Periodo</label>
        <Calendar inputId="Periodo" v-model="periodo" view="month" dateFormat="yy-mm" :disabled="data.load" />
      </div>

      <div class="col-span-3 sm:col-span-2">
        <label for="Vence1" class="block text-sm font-medium text-gray-700">1&ordm; Vencimiento</label>
        <Calendar inputId="Vence1" v-model="data.save.vence1" dateFormat="yy-mm-dd" />
      </div>

      <div class="col-span-3 sm:col-span-2">
        <label for="Vence2" class="block text-sm font-medium text-gray-700">2&ordm; Vencimiento</label>
        <Calendar inputId="Vence2" v-model="data.save.vence2" dateFormat="yy-mm-dd" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="Observaciones1" class="block text-sm font-medium text-gray-700">Observaciones Renglon 1</label>
        <InputText inputId="Observaciones1" type="text" v-model="data.save.obs1" class="w-full" maxlength="80" />
        <small class="text-gray-400">Caractecteres restantes: {{80 - data.save.obs1.length}}</small>
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="Observaciones2" class="block text-sm font-medium text-gray-700">Observaciones Renglon 2</label>
        <InputText inputId="Observaciones2" type="text" v-model="data.save.obs2" class="w-full" maxlength="80" />
        <small class="text-gray-400">Caractecteres restantes: {{80 - data.save.obs2.length}}</small>
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="Observaciones3" class="block text-sm font-medium text-gray-700">Observaciones Renglon 3</label>
        <InputText inputId="Observaciones3" type="text" v-model="data.save.obs3" class="w-full" maxlength="80" />
        <small class="text-gray-400">Caractecteres restantes: {{80 - data.save.obs3.length}}</small>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <label for="Lugar1" class="block text-sm font-medium text-gray-700">Lugares de pago Linea 1</label>
        <InputText inputId="Lugar1" type="text" v-model="data.save.lugar1" class="w-full" maxlength="80" />
        <small class="text-gray-400">Caractecteres restantes: {{80 - data.save.lugar1.length}}</small>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <label for="Lugar2" class="block text-sm font-medium text-gray-700">Lugares de pago Linea 2</label>
        <InputText inputId="Lugar2" type="text" v-model="data.save.lugar2" class="w-full" maxlength="80" />
        <small class="text-gray-400">Caractecteres restantes: {{80 - data.save.lugar2.length}}</small>
      </div>

      <div class="col-start-2 col-span-4 justify-self-center relative-container">
  <Button
    @click="putPeriodo"
    label="Generar Facturaci&oacute;n"
    class="p-button-outlined p-button-warning w-full"
    :disabled="data.load"
  />
  <div v-if="data.load" class="overlay-progress">
    <ProgressBar :value="data.progress" style="height: 2.5rem" />
  </div>
</div>
        
      <div>
        <input  class="col-start-2 col-span-4 justify-self-center" type="checkbox" id="checkbox" value="Jack" v-model="checked">
        <label for="jack">  Actualizar Vencimientos</label>

      </div>

      <Toast position="bottom-center" group="bc">
      <template #message="slotProps">
          <div class="w-full">
              <div class="w-full">
                <i class="pi pi-exclamation-triangle" style="font-size: 5rem"></i>
                <h4>{{slotProps.message.summary}}</h4>
                <p>{{slotProps.message.detail}}</p>
              </div>
              <br/>
              <div class="w-full">
                  <div class="w-full">
                      <Button class="p-button-success" label="Si" @click="onConfirm" style=" width: 100%; margin-bottom: .5rem;"></Button>
                      <Button class="p-button-secondary" label="No" @click="onReject" style=" width: 100%; margin-bottom: .5rem;"></Button>
                  </div>
              </div>
          </div>
      </template>
    </Toast>

      

    </div>
  </div>
</template>
<script>
  
  import { ref, reactive, onMounted, watch } from 'vue';
  import WService from '@/plugins/ws';
  import moment from 'moment';
  import Calendar from 'primevue/calendar';
  import InputText from 'primevue/inputtext';
  import Button from 'primevue/button';
  import AutoComplete from 'primevue/autocomplete';
  import ProgressBar from 'primevue/progressbar';
  import Toast from 'primevue/toast';
  import { useToast } from 'primevue/usetoast';
  import InputSwitch from 'primevue/inputswitch';
  export default {
    components: {
      Calendar, InputText, Button, ProgressBar,InputSwitch,Toast,AutoComplete
    },
  
    data() {

    return {
      switchValue: false,
      };
     },
    setup() {
      const toast = useToast();
      const wService = ref(new WService());
      const fecha = new Date();
      const periodo = ref(fecha);
      const load = ref(false);
      const empresa = ref();
      var TipoFact = "Afiliados";
      var facturacionGlobalText = "Facturación Global";
      const data = reactive({
        load: true,
        progress: 0,
        idEmpresa: 0,
        save: {
          idVence: 0,
          esEmpresa: false,
          idEmpresaSelect: 0,
          vence1: fecha,
          vence2: fecha,
          obs1: 'No adeude mas de dos cuotas o será suspendido.',
          obs2: '',
          obs3: '',
          lugar1: 'Banco Santiago del Estero - Sol Pago -Home Banking- Link Celular y Cajero Link',
          lugar2: 'Home Banking. Link Celular y cajero LINK'
        },
        empresasFiltradas: []
      });
 
      onMounted(() => {
        getPeriodo();
      })

     

      const getPeriodo = () => {
        let per = moment(periodo.value).format("YYYYMM")
        data.load = true;
        wService.value.getMethod(`/Vencimientos/Otro/${per}`).then(info => {
          data.save.idVence = info.idPeriodo;
          if (info.renglon_1)
            data.save.obs1 = info.renglon_1;
          if (info.renglon_2)
            data.save.obs2 = info.renglon_2;
          if (info.renglon_3)
            data.save.obs3 = info.renglon_3;
          if (info.lugar_de_pago1)
            data.save.lugar1 = info.lugar_de_pago1;
          if (info.lugar_de_pago2)
            data.save.lugar2 = info.lugar_de_pago2;
          data.save.vence1 = new Date(info.vencimiento_1);
          if (info.vencimiento_2)
            data.save.vence2 = new Date(info.vencimiento_2);
          data.load = false;
        }).catch(err => {
          console.log(err.message);
          data.load = false;
        });
      }

      const onReject = (event) => {
          toast.removeGroup('bc');
        }


      const switchFacturacion = () => {
        if(TipoFact == "Afiliados"){
          TipoFact = "Empresa";
        }
        else{
          TipoFact = "Afiliados";
        }
        // console.log(TipoFact)
      }

      const putPeriodo = () => {
        data.load = true;
        data.progress = 0;
          let dato = {
            "idEmpresa": data.idEmpresa,
            "idPeriodo": data.save.idVence,
            "periodo": moment(periodo.value).format("YYYYMM"),
            "vencimiento_1": moment(data.save.vence1).format("YYYY-MM-DD"),
            "vencimiento_2": moment(data.save.vence2).format("YYYY-MM-DD"),
            "renglon_1": data.save.obs1,
            "renglon_2": data.save.obs2,
            "renglon_3": data.save.obs3,
            "lugar_de_pago1": data.save.lugar1,
            "lugar_de_pago2": data.save.lugar2,
            "anulado": false,
            
          };
          // console.log(TipoFact);
          // console.log(dato.periodo);
          // console.log(dato.idEmpresa);
          if(checkbox.checked){
            wService.value.postMethod(`/IosepSalud/ActualizarVencimiento?Periodo=${dato.periodo}&fecven1=${dato.vencimiento_1}&fecven2=${dato.vencimiento_2}&obs1=${data.save.obs1.toString()}&obs2=${data.save.obs2.toString()}&obs3=${data.save.obs3.toString()}&lug1=${data.save.lugar1.toString()}&lug2=${data.save.lugar2.toString()}`).then(info => {
          // console.log("Get: ", info);
          data.progress = 10;
          }).catch(err => {
            console.log(err.message);
            data.load = false;
          });
          } else { 
          wService.value.postMethod(`/IosepSalud/VerificarVencimientos?Periodo=${dato.periodo}`)
          }
          if(TipoFact=="Afiliados"){
          setInterval(updateProgress, 30000); 
          }else{
          setInterval(updateProgress, 1200);
          }
          wService.value.getMethod(`/IosepSalud/GlobalRecibos?Id=${dato.idEmpresa}&P=${dato.periodo.toString()}&O1=${data.save.obs1.toString()}&O2=${data.save.obs2.toString()}&O3=${data.save.obs3.toString()}&L1=${data.save.lugar1.toString()}&L2=${data.save.lugar2.toString()}&F1=${dato.vencimiento_1}&F2=${dato.vencimiento_2}&Tipo=${TipoFact}&afecta=1`).then(info => {
            data.progress =100;
            if(info === "Usuario no valido") {
              toast.add({severity:'error', summary: 'Mensaje de error', detail:'El usuario no está autorizado', life: 30000});
            }
            else {
              toast.add({severity:'success', summary: 'Mensaje exitoso', detail:'Se realizó la facturación', life: 30000});
            }
            toast.removeGroup('bc');
        }).catch(err => {
          console.log(err.message);
          toast.add({severity:'error', summary: 'Mensaje de error', detail:'La facturación tuvo un inconveniente', life: 30000});
          data.progress =100;
          data.load = false;
          });
      }


      
      
      function updateProgress() {
        // Incrementar el progreso en un valor fijo
        if (data.progress <= 90){
          data.progress += 1;
        } 
      }

      const buscarEmpresa = (event) => {
        if (!load.value) {
          load.value = true;
          setTimeout(() => {
            if (event.query.length > 2 || event.query.length === 0) {
              wService.value.getMethod('empresas/' + event.query).then(info => {
                data.empresasFiltradas = info;
                data.empresasFiltradas.forEach((empresa) => {
                  empresa.nombre = empresa.nombre.trim();
                });
                load.value = false;
              }).catch(err => {
                console.log(err.message);
                load.value = false;
              });
            }
            else
              load.value = false;
          }, 250);
        }
      }

      const onAutoCompleteInput = (newValue) => {
        if (newValue.data === null) {
          data.idEmpresa = 0
        }
      }

      const saveIdEmpresa = (event) => {
        data.idEmpresa = event.value.idEmpresa;
      }

      watch(periodo, async (newValue, oldValue) => {
        if (newValue !== oldValue) {
          getPeriodo();
        }
      })

      return {
        data, periodo, empresa,

        getPeriodo, putPeriodo,switchFacturacion,TipoFact,facturacionGlobalText,onReject,buscarEmpresa,saveIdEmpresa,onAutoCompleteInput
      }
    }
  }
</script>

<style>
.flex-container {
  display: flex;
  align-items: center;
  gap: 10px;
} 
</style>